"use client";

import React, { useCallback, useEffect, useState } from "react";
import { deviceDetector, pubsub } from "utils";
import { useBridge } from "@/src/lib/bridge";
import { MessageType } from "@/src/lib/bridge/types";
import { pubSubKeyMap } from "@utils/pubSubKeyMap";
import EdgenDrawer from "../Drawer";
import { VoicePermissionDeniedContent } from "./VoicePermissionDeniedContent";

export const VoicePermissionDeniedModalContainer: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const { request, isInApp } = useBridge();

  const closeModal = useCallback(() => {
    setVisible(false);
  }, []);

  const openModal = useCallback(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    if (!deviceDetector.isApp()) {
      return;
    }
    const unsubscribe = pubsub.on(
      pubSubKeyMap.OPEN_VOICE_PERMISSION_MODAL,
      () => openModal(),
    );
    return () => unsubscribe();
  }, [openModal]);

  const handleOpenSettings = useCallback(async () => {
    try {
      if (isInApp && request) {
        await request(MessageType.VOICE_PERMISSION, {
          action: "open-settings",
        });
      }
    } finally {
      closeModal();
    }
  }, [closeModal, isInApp, request]);

  if (!deviceDetector.isApp()) {
    return null;
  }

  return (
    <EdgenDrawer
      isOpen={visible}
      onClose={closeModal}
      placement="bottom"
      width="100%"
      isHiddenClose={true}
      contentClassName="pb-0 no-scrollbar"
      isMask={false}
      maskClosable={false}
      styles={{
        body: { padding: "24px 24px 0 24px", scrollbarWidth: "none" },
        wrapper: { height: "301px" },
      }}
    >
      <VoicePermissionDeniedContent
        onOpenSettings={handleOpenSettings}
        onCancel={closeModal}
      />
    </EdgenDrawer>
  );
};
